import AxiosInstance from '../../../http-config';
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey';
import { getAppConfigurationValue } from '../../../../redux/helpers';
import { FranjaHorariaModel } from './model/franjaHorariaModel';

export const apiGetFranjasHorarias = async (): Promise<FranjaHorariaModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia);

  return await AxiosInstance.get(`${apiSuffixUrl}/api/FranjaHoraria`).then(response => {
    return response.data;
  });
};
